import { clsx } from 'clsx'
import type { ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// tailwind-merge only knows Tailwind's default font sizes, so it reads the
// custom ramp in tailwind.config.js (text-label-sm, …) as text colors and
// drops them when a color class follows. Keep this list in sync with fontSize.
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [
                {
                    text: [
                        'title-lg',
                        'title-md',
                        'title-sm',
                        'body-lg',
                        'body-md',
                        'body-sm',
                        'label-lg',
                        'label-md',
                        'label-sm',
                    ],
                },
            ],
        },
    },
})

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
